<app-header></app-header>

<div class="container gift-card-confirmation">
  <section
    class="gift-card-confirmation__card"
    [ngClass]="{'gift-card-confirmation__card--failed': !isSuccess}"
  >
    <div
      class="gift-card-confirmation__status-icon"
      [ngClass]="{'gift-card-confirmation__status-icon--failed': !isSuccess}"
    >
      <svg *ngIf="isSuccess" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
          fill="currentColor"
        />
      </svg>
      <svg *ngIf="!isSuccess" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M18.3 5.7 12 12l6.3 6.3-1.4 1.4L10.6 13.4 4.3 19.7 2.9 18.3 9.2 12 2.9 5.7 4.3 4.3l6.3 6.3 6.3-6.3z"
          fill="currentColor"
        />
      </svg>
    </div>

    <h1>
      {{ (isSuccess
        ? 'marketplace.gift-card.confirmation.success.title'
        : 'marketplace.gift-card.confirmation.failure.title') | transloco }}
    </h1>

    <p *ngIf="isSuccess" class="gift-card-confirmation__lead">
      {{ 'marketplace.gift-card.confirmation.success.lead' | transloco }}
    </p>

    <p *ngIf="isSuccess" class="gift-card-confirmation__message">
      <ng-container *ngIf="expectedDeliveryDate; else immediateDelivery">
        {{ 'marketplace.gift-card.confirmation.success.message.scheduled' | transloco : {date: expectedDeliveryDate} }}
      </ng-container>
      <ng-template #immediateDelivery>
        {{ 'marketplace.gift-card.confirmation.success.message.immediate' | transloco }}
      </ng-template>
    </p>

    <p *ngIf="!isSuccess" class="gift-card-confirmation__message">
      {{ 'marketplace.gift-card.confirmation.failure.message' | transloco }}
    </p>

    <p *ngIf="!isSuccess" class="gift-card-confirmation__help">
      {{ 'marketplace.gift-card.confirmation.failure.help' | transloco }}
    </p>

    <div class="gift-card-confirmation__actions">
      <a routerLink="/" class="button button--secondary">
        {{ 'marketplace.gift-card.confirmation.actions.home' | transloco }}
      </a>
      <a
        routerLink="/gift-card"
        class="button button--primary"
      >
        {{ (isSuccess
          ? 'marketplace.gift-card.confirmation.actions.new'
          : 'marketplace.gift-card.confirmation.actions.retry') | transloco }}
      </a>
    </div>
  </section>
</div>

<app-footer></app-footer>
